import * as React from "react";
import axios from "axios";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useRequestNewPasswordMutation } from "../Slices/roomNateApis";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

export default function EmailOtpConfirmation({
  dialogOpen,
  setDialogOpen,
  sendTo,
  title,
  afterConfirmation,
  setOtpConfimed,
}) {
  const [otp, setOTP] = React.useState(Array(6).fill(""));
  const inputRefs = React.useRef([]);
  const [resendCountdown, setResendCountdown] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [requestNewPassword] = useRequestNewPasswordMutation();

  React.useEffect(() => {
    let intervalId;
    if (resendCountdown > 0) {
      intervalId = setInterval(() => {
        setResendCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [resendCountdown]);

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleInputChange = (index, value) => {

    const oldValue = otp[index];
    const newOTP = otp.map((otp, i) => i === index ? value : otp);
    setOTP(newOTP);

    if (value && index < 5 && inputRefs.current[index + 1] !== null) 
      inputRefs.current[index + 1]?.focus();
    
    else if (!oldValue  && index > 0 && inputRefs.current[index - 1] !== null) 
      inputRefs.current[index - 1]?.focus();
  };

  const verifyOtpSubmit = async () => {
    try {
      setLoading(true);
      await axios.post(`/user/verifyOtp`, {
        validationCode: otp.join(''),
        email: sendTo,
      });
      setOtpConfimed(otp.join(''));
      afterConfirmation();
    } catch (err) {
      setError("Invalid or Expired OTP");
    } finally {
      setLoading(false);
    }
  };

  const resendOtpSubmit = async () => {
    try {
      requestNewPassword({
        body: {
          email: sendTo
        }
      })
    } catch (err) {
    }
  };

  return (
    <Dialog
      open={dialogOpen}
      PaperProps={{
        sx: { borderRadius: "9px" },
      }}
      maxWidth="xs"
      fullWidth
    >
      <Card component={Paper}>
        {true && (
          <CardHeader
            action={<IconButton color="secondary" aria-label="close" onClick={handleCloseDialog}  sx={{ fontSize: '12px' }}  > <CloseOutlinedIcon sx={{ fontSize: '12px' }}  /> </IconButton>}
          />
        )}

        <CardContent>
          {loading ? (
            <Typography variant="subtitle1" textAlign={"center"}>
              {"Loading"}
            </Typography>
          ) : (
            <>
              <Typography variant="subtitle1" textAlign={"center"} mb={2} fontWeight="bold">
                {title}
              </Typography>
              {error.length > 0 && (
                <>
                  <Alert severity="error" sx={{ width: "100%" }}>
                    {error}
                  </Alert>
                  <br></br>
                </>
              )}

              <Typography textAlign={"center"} mb={2}>
                Code has sent to {sendTo}
              </Typography>
              <Stack gap={2} flexDirection={"row"} justifyContent={"center"}>
                {[...Array(6)].map((_, index) => (
                  <Box key={index}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                      value={otp[index] || ""}
                      onPaste={(e) => {
                        const pastedData = e.clipboardData.getData("text").slice(0, 6 - index);
                        setOTP((prevOtp) => {
                          const newOtp = [...prevOtp];
                          for (let i = 0; i < pastedData.length && index + i < 6; i++) {
                            newOtp[index + i] = pastedData[i];
                          }
                          return newOtp;
                        });

                        const nextIndex = index + pastedData.length - 1;
                        if (nextIndex < inputRefs.current.length) {
                          inputRefs.current[nextIndex]?.focus();
                        }

                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace") {
                          handleInputChange(index, "");
                        } else if (/^[0-9]$/.test(e.key)) {
                          handleInputChange(index, e.key);
                        }
                      }}
                      inputRef={(ref) => (inputRefs.current[index] = ref)}
                    />
                  </Box>
                ))}
              </Stack>

              <Button variant="contained" fullWidth sx={{ mt: 2 }} color="primary" onClick={() => verifyOtpSubmit()}>
                Verify
              </Button>

              {resendCountdown === 0 ? (
                <Typography textAlign="center" mt={2}>
                  Have not received the verification code?{" "}
                  <Typography
                    color="primary"
                    fontWeight="bold"
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setResendCountdown(59);
                      resendOtpSubmit();
                    }}
                  >
                    Resend
                  </Typography>
                </Typography>
              ) : (
                <Typography textAlign="center" mt={2} variant="body2">
                  We've sent you again now you can resend code in {resendCountdown} seconds
                </Typography>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </Dialog>
  );
}
